import React, { useState, useEffect, useContext } from "react";
import USER from "components/context/UserContext";
import { useNavigate } from "react-router-dom";
import styles from "styles/profilepage.module.css";
import UserProfile from "components/profile/UserProfile";
import Loading from "components/loadings/Loading";
import Nav from "components/nav/Navbar";
import FooterDev from "components/footer/FooterDev";

export default function Profile() {
  const navigate = useNavigate();
  const { user } = useContext(USER);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user.isLoggedIn) {
      navigate("/");
    } else if (user.data) {
      setLoading(false);
    }
  }, [user, navigate]);

  return (
    <>
      <div className={`text-gray-50 ${styles.profileBackground}`}></div>
      <div className="text-gray-50">
        <Nav />
        <div
          className={`text-gray-100 min-h-screen p-6 ${styles.profile_btn_layout}`}
        >
          {user.data && (
            <div className={styles.glass_profile}>
              <UserProfile setLoading={setLoading} />
            </div>
          )}

          {loading && <Loading />}
        </div>
        <FooterDev />
      </div>
    </>
  );
}
